import { IBlogRollPaginationStyle } from "@pageBuilder/typings";
import { CssProperties } from "../../../models/css-property";
import { ElementStyleService } from "../../../services/element-style.service";

export class BlogRollPaginationStylesRenderer {

    constructor(protected readonly styleService: ElementStyleService) {}

    public render(element: HTMLElement, style: IBlogRollPaginationStyle): void {
        this.cleanup(element);

        const buttonWrapperProp = new CssProperties();
        buttonWrapperProp.tryAdd("--button-alignment", style.alignment);
        this.styleService.setStyle(element, `#${element.id} .pagination-wrapper`, buttonWrapperProp.data);

        const buttonProps = new CssProperties();
        buttonProps.tryAdd("color", style?.buttonColor);
        this.styleService.setStyle(element, `#${element.id} .pagination-wrapper .pagination-button`, buttonProps.data);

        const arrowProps = new CssProperties();
        arrowProps.tryAdd("border-color", style?.buttonColor);
        this.styleService.setStyle(element, `#${element.id} .pagination-wrapper .pagination-button span::before`, arrowProps.data);

        const activeButtonProps = new CssProperties();
        activeButtonProps.tryAdd("color", style?.activeButtonColor);
        this.styleService.setStyle(element, `#${element.id} .pagination-wrapper .active .pagination-button`, activeButtonProps.data);
    }

    public cleanup(element: HTMLElement): void {
        const selectors = this.getStyleSelectors(element);
        selectors.forEach(selector => {
            this.styleService.clearStyle(element, selector);
        });
    }

    public getStyleSelectors(element: HTMLElement): string[] {
        return [
            `#${element.id} .pagination-wrapper .pagination-button`,
            `#${element.id} .pagination-wrapper .pagination-button span::before`,
            `#${element.id} .pagination-wrapper .active .pagination-button`
        ];
    }

}
